import { TransactionItem } from "./Transaction";

export const TRANSACTIONS: TransactionItem[] = [
  {
    id: "phone",
    icon: "phone",
    title: "Phone",
    amount: 120,
  },
  {
    id: "internet",
    icon: "wifi",
    title: "Internet",
    amount: 95,
  },
  {
    id: "electricity",
    icon: "utilities",
    title: "Electricity",
    amount: 160,
  },
  {
    id: "rent",
    icon: "house",
    title: "Rent",
    amount: 1_000,
    isAch: true,
  },
];

export const SLIDES = [
  {
    description: (
      <>
        Traditionally, managing the timing of your recurring expenses is a
        delicate balancing&nbsp;act.
      </>
    ),
    ewaTransactions: [],
  },
  {
    description: (
      <>
        When your Earnings Balance is active, Switchboard sorts your expenses
        efficiently between your&nbsp;accounts.
      </>
    ),
    ewaTransactions: ["phone", "internet"],
  },
];
export const CHECKING_BALANCE_START = 1_200;
export const EARNINGS_BALANCE_START = 250;
